import { JSONAPI_URLS } from '../../../consts/endpoints';
import { getData } from '../../../utils/http';
import { isArray, isDefined } from '../../../utils/isDefined';
import urlCreator from '../../../utils/urlCreator';

const getSimcard = async ({ clientId, icc }) => {
  try {
    const queryParams = {
      include: ['owner'],
      fields: { users: 'name' },
      filter: {
        client_id: clientId,
        icc
      }
    };

    let simcard = void 0;

    const { data } = await getData(
      urlCreator(JSONAPI_URLS.SIM_CARDS, queryParams)
    );

    if (isDefined(data) && isArray(data)) {
      simcard = data[0];
    }

    return { simcard };
  } catch (e) {
    return { error: e.response.data.errors };
  }
};

export default getSimcard;
